import { render, staticRenderFns } from "./InsertOptionProduct.vue?vue&type=template&id=1daf2565&scoped=true"
import script from "./InsertOptionProduct.vue?vue&type=script&lang=js"
export * from "./InsertOptionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf2565",
  null
  
)

export default component.exports